// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../graphql/api/index';

import { gql } from 'graphql-tag';
import { ImageCommonFragmentDoc } from './imageCommon.fragment.generated';
import { ImageSizeFragmentDoc } from './imageSize.fragment.generated';
export const ImageCoverFragmentDoc = gql`
    fragment imageCover on Image {
  ...imageCommon
  size: size(name: COVER) {
    ...imageSize
  }
  size_x2: size(name: COVER_X2) {
    ...imageSize
  }
}
    ${ImageCommonFragmentDoc}
${ImageSizeFragmentDoc}`;